import React from 'react';
import styled, { css } from 'styled-components';
import { palette } from '@landr/maestro-legacy';
import { useLocation } from 'react-router-dom';
import { RoutePaths } from 'types/enums';

const DynamicGradient = styled.div<{
    gradientColor: string;
    gradientOpacity: number;
    showLongerGradient: boolean;
    isForYouPage: boolean;
}>`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 350px;

    ${({ showLongerGradient }) =>
        showLongerGradient &&
        css`
            height: 450px;
        `};

    ${({ isForYouPage }) =>
        isForYouPage &&
        css`
            height: 650px;
        `};

    ${({ gradientOpacity }) =>
        css`
            opacity: ${gradientOpacity};
        `};

    ${({ gradientColor }) =>
        css`
            background-image: linear-gradient(
                    180deg,
                    rgba(12, 27, 43, 0) 0%,
                    rgba(12, 27, 43, 0.6) 38.54%,
                    rgba(12, 27, 43, 1) 100%
                ),
                url(data:image/png;base64,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),
                radial-gradient(
                    63.97% 104.48% at 58.35% 21.58%,
                    ${gradientColor} 0%,
                    ${palette('neutral.900')} 100%
                );
        `};
`;

const Gradient = ({
    backgroundColor,
    opacity,
}: {
    backgroundColor: string;
    opacity: number;
}) => {
    const { pathname } = useLocation();

    const routePathForLongGradiant = [
        RoutePaths.Packs,
        RoutePaths.Artists,
        RoutePaths.UserCollections,
        RoutePaths.Genres,
        RoutePaths.Instruments,
        RoutePaths.Labels,
        RoutePaths.Collections,
        RoutePaths.Charts,
        RoutePaths.Exclusives,
        RoutePaths.QuickPicks,
    ];

    const showLongerGradient = routePathForLongGradiant.some(
        (route) => pathname.indexOf(route) !== -1,
    );

    const isForYouPage = pathname === '/';

    return (
        <DynamicGradient
            gradientColor={backgroundColor}
            gradientOpacity={opacity}
            showLongerGradient={showLongerGradient}
            isForYouPage={isForYouPage}
        />
    );
};

export default Gradient;
